import ConfirmNumberPage from './ConfirmNumberPage';

export default ConfirmNumberPage;


// WEBPACK FOOTER //
// ./src/components/pages/ConfirmNumberPage/index.js